import { Component, Input } from '@angular/core';
import { AuthService, DatasourceService } from '@app/core/services';
import { BaseListComponent } from './base-list.component';
import { State, aggregateBy, AggregateResult } from "@progress/kendo-data-query";
import { IntlService } from '@progress/kendo-angular-intl';


@Component({
  selector: 'credits-list',
  template: `
  <kendo-grid [style.height.%]="100" [data]="view | async">

    <ng-template kendoGridNoRecordsTemplate>
      Sin registros.
    </ng-template>

    <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        # {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="entry_date" title="Fecha" width="120" *ngIf="view_date">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
        <kendo-grid-cell-date [text]="dataItem.date" [time]="false"></kendo-grid-cell-date>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="name" title="Concepto" width="200"></kendo-grid-column>    
    <kendo-grid-column field="customer_name" title="Cliente" width="200"></kendo-grid-column>
    <kendo-grid-column field="person_name" title="Recibió" width="200"></kendo-grid-column>
    <kendo-grid-column field="partiality" title="Parcialidad" width="80"></kendo-grid-column>
    <kendo-grid-column field="amount" title="Cantidad" width="120" format="{0:c}" [style]="{'text-align': 'right'}">
      <ng-template kendoGridFooterTemplate>
        <div style="text-align: right;">{{intl.formatNumber(total?.amount?.sum, 'c2')}}</div>
      </ng-template>
    </kendo-grid-column>    

  </kendo-grid>
  `,
  styles: [``],
  providers:  [ DatasourceService ]
})
export class CreditsListComponent extends BaseListComponent {

  //Variables

  protected table: string = 'payments';

  //Input: range
  public _range = { start: '', end: '' };

  @Input()
  set range(range: any) {
    this._range = range;
    
    let that = this;
    this.state = this.getInitialState();
    this.service.pagination(this.table, this.state, function(result, table, state){
      console.log(result, table, state);
      // that.visible = result.data.length;
      that.total = aggregateBy(result.data, [
        { field: "amount", aggregate: "sum" }
      ]); 
      
      if(Object.keys(that.total).length === 0) 
        that.total = {amount: {sum: 0}};
    
      that.resultChange.emit({name: `CREDITS_${that.payment_type}`, result: result, sum: that.total.amount.sum});

    })

  }

  get range(): any { return this._range; }

  @Input() payment_type: string = '';

  @Input() view_date: boolean = true;

  public total: AggregateResult;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected intl: IntlService) {

    super(authService, service, intl);
    console.log(this.range);

  }

  //Overrides
  protected getInitialState() : State {

    // let target: string = (this.type == 'ENTRY') ? 'entry_date': 'output_date';

    let s : State = {
      skip: 0, 
      take: 0, 
      sort: [      
        {field: 'date', dir: 'asc'},
        {field: 'name', dir: 'asc'}
      ], 
      filter: {
        logic: "and",
        filters: [   
          {
            field: 'id_status',
            operator: 'eq',
            value: 1
          }, 
          {
            field: 'id_payment_type',
            operator: 'in',
            value: this.payment_type
          },            
          {
            field: 'date',
            operator: 'inrange',
            // value: `${this._date} 00:00:00,${this._date} 23:59:59`
            value: `${this._range.start} 00:00:00,${this._range.end} 23:59:59`
          }
        ]
      }, 
      group: []
    }

    return s;

  }
  
}
